import { useEffect, useMemo } from "react";
import { CardHeader } from "reactstrap";
import Loading from "../../../../components/Loaders/Loading";
import ChartView from "../../../ReportV2/Preview/ChartView";
import { useGetReport } from "../../../ReportV2/api";

const Content = ({ reportId, chartType }) => {
  const { getReport, report, loading } = useGetReport();

  useEffect(() => {
    const controller = new AbortController();
    getReport(reportId, controller);
    return () => controller.abort();
  }, [getReport, reportId]);

  const values = useMemo(
    () => {
      const [_chartType, index] = (chartType || "").split(".");
      return {
        ...report?.reportData?.settings,
        chartConfigurations: report?.reportData?.settings?.chartConfigurations?.filter(
          (item, i) => item.chartType === _chartType && i === Number(index)
        ),
      }
    }, [chartType, report?.reportData?.settings]);

  return (
    <div className="w-100 h-100 d-flex flex-column">
      <CardHeader className="font-weight-bold">{report?.name}</CardHeader>
      {loading ? <Loading /> : (
        <ChartView
          values={values}
          dashboard={true}
          reportId={reportId}
        />
      )}
    </div>
  );
};

export default Content;
